module.exports = __webpack_public_path__ + "img/kilwins.be66c334.png";